import React, { useState, useEffect, useRef } from "react";
import classes from "./ProgressSub.module.css";
import { check_subscription_api } from "../Services/Apis";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/mtn.png";
import funnyBoneImg from "../Assets/logo.png";
import Cookies from "js-cookie";

const ProgressSub = () => {
  const params = new URLSearchParams(window.location.search);
  const number = params.get("msisdn");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const attemptsRef = useRef(0); // Persist attempts count

  const checkSubscription = async () => {
    if (!number) return;
    setLoading(true);

    try {
      const response = await axios.get(`${check_subscription_api}?msisdn=${number}`);
      console.log(response);
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response?.data || "ERROR";
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const maxRetries = 5;
    const delay = 10000;

    const retryCheck = async () => {
      const result = await checkSubscription();
      if (result === "SUCCESS") {
        Cookies.set('sub_number',number)
        console.log('success',maxRetries)
        navigate("/home");
        return;
      }

      attemptsRef.current += 1;
      if (attemptsRef.current < maxRetries) {
        setTimeout(retryCheck, delay);
      } else {
        navigate("/subscribe");
      }
    };

    setTimeout(()=>{
      retryCheck();
    },3000)

  }, [navigate]); // Add navigate to dependency array

  return (
    <div className={classes.container}>
      <div className={classes.sub_container}>
        <img src={logo} alt="..." className={classes.logo} />
        <p className={classes.title}>
          {"Subscription In Progress..".split("").map((char, index) => (
            <span key={index} style={{ "--i": index }}>{char}</span>
          ))}
        </p>
        <img src={funnyBoneImg} alt="..." className={classes.funny_img} />
        <p className={classes.text}>Thank You For Waiting....</p>
      </div>
    </div>
  );
};

export default ProgressSub;
